import api from './api';

/**
 * Kai — the platform's grounded assistant (kai-service via the gateway).
 *
 * Kai answers from an audience-scoped knowledge base only; it never
 * returns prices, addresses, or PII, and hands account-specific asks off
 * to a human. Pass the `conversation_id` from the previous answer back in
 * to keep the thread going.
 */
const kaiService = {
  ask: (question, conversationId) =>
    api.post('/kai/ask', {
      question,
      ...(conversationId ? { conversation_id: conversationId } : {}),
    }),
  listConversations: () => api.get('/kai/conversations'),
  getMessages: (conversationId) =>
    api.get(`/kai/conversations/${conversationId}/messages`),
};

export default kaiService;
